/**
 * @name galaxy
 * @description Lucide SVG string.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTYuMDA1IDE1LjEwOGE1LjA0MSA2LjUyIDI4LjI1IDAwLTguMDA4LTYuMjE3IDUuMDQxIDYuNTIgMjguMjUgMDA4LjAwOCA2LjIxN0ExMS44ODQgNy4yODgtNjAuNzYgMDE0LjAyOSA3LjAwMSIgLz4KICA8cGF0aCBkPSJNMTcgMjFoLjAxIiAvPgogIDxwYXRoIGQ9Ik03IDNoLjAxIiAvPgogIDxwYXRoIGQ9Ik03Ljk5NyA4Ljg5MWExMS44ODUgNy4yODgtNjAuNzU2IDAxMTEuOTc3IDguMTA3IiAvPgogIDxjaXJjbGUgY3g9IjEyIiBjeT0iMTIiIHI9IjEiIGZpbGw9ImN1cnJlbnRDb2xvciIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/galaxy
 * @see https://lucide.dev/guide/packages/lucide-static - Documentation
 *
 * @returns {String}
 *
 */
const Galaxy: string = `
<svg
  class="lucide lucide-galaxy"
  xmlns="http://www.w3.org/2000/svg"
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  stroke="currentColor"
  stroke-width="2"
  stroke-linecap="round"
  stroke-linejoin="round"
>
  <path d="M16.005 15.108a5.041 6.52 28.25 00-8.008-6.217 5.041 6.52 28.25 008.008 6.217A11.884 7.288-60.76 014.029 7.001" />
  <path d="M17 21h.01" />
  <path d="M7 3h.01" />
  <path d="M7.997 8.891a11.885 7.288-60.756 0111.977 8.107" />
  <circle cx="12" cy="12" r="1" fill="currentColor" />
</svg>
`;

export default Galaxy;
